import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useMemo, useRef } from "react";
import { useTable } from "react-table";
import { DATA_GRID_DISPLAY_NAME } from "./constants";
import { TableBody, TableHeader } from "./components";
import { getClassName } from "./utils";
export var ComparisonGrid = function ComparisonGrid(props) {
  var ariaDescribedBy = props.ariaDescribedBy,
      ariaLabelledBy = props.ariaLabelledBy,
      data = props.data,
      columns = props.columns,
      caption = props.caption,
      className = props.className,
      useDefaultColspan = props.useDefaultColspan,
      getRowId = props.getRowId,
      getHeaderProps = props.getHeaderProps,
      getCellProps = props.getCellProps,
      getColumnProps = props.getColumnProps,
      getRowProps = props.getRowProps;
  var tableRef = useRef();
  var tableConfig = useMemo(function () {
    var config = {
      columns: columns,
      data: data,
      getRowId: getRowId
    };
    return config;
  }, [data, columns]);

  var _useTable = useTable(tableConfig),
      rows = _useTable.rows,
      headerGroups = _useTable.headerGroups,
      getTableProps = _useTable.getTableProps,
      getTableBodyProps = _useTable.getTableBodyProps,
      prepareRow = _useTable.prepareRow;

  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "wrapper",
      className: className
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "tableWrapper"
    })
  }, /*#__PURE__*/React.createElement("table", _extends({}, getTableProps(), {
    "aria-describedby": ariaDescribedBy,
    "aria-labelledby": ariaLabelledBy,
    className: getClassName({
      descendantName: "table"
    })
  }), caption && /*#__PURE__*/React.createElement("caption", {
    className: getClassName({
      descendantName: "caption"
    })
  }, caption), /*#__PURE__*/React.createElement("thead", {
    className: getClassName({
      descendantName: "tableHeader"
    })
  }, /*#__PURE__*/React.createElement(TableHeader, {
    headerGroups: headerGroups,
    useDefaultColspan: useDefaultColspan,
    getColumnProps: getColumnProps,
    getHeaderProps: getHeaderProps
  })), /*#__PURE__*/React.createElement("tbody", _extends({}, getTableBodyProps(), {
    ref: tableRef,
    className: getClassName({
      descendantName: "tableBody"
    })
  }), /*#__PURE__*/React.createElement(TableBody, {
    rows: rows,
    columns: columns,
    prepareRow: prepareRow,
    getCellProps: getCellProps,
    getColumnProps: getColumnProps,
    getRowProps: getRowProps
  })))));
};
ComparisonGrid.displayName = DATA_GRID_DISPLAY_NAME;